export const carrierVerificationStatus = {
  pending: 'high_value_pending_verification',
  verified: 'high_value_verified',
};
